import { CardStatement } from "@/modules/card/components";

export const CardStatementPage = () => {

  return (
    <div className="full-width page-container">
      <CardStatement />
    </div>
  );
};
